export default __webpack_public_path__ + "static/media/thyroid.db99b6df.jpg";